module.exports = __webpack_public_path__ + "static/media/daterange2Icon.51009d71.svg";